import {
  memo,
  FunctionComponent,
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';
import { OpenCase as OpenCaseType } from '~types';
import _, { findLastIndex } from 'lodash';

import {
  useFastMode,
  useGameCount,
  useSliderStyle,
  useStatusGame,
  useSuperPrizeMode,
} from '../hooks';
import { GetName } from '~frontend/components/item';
import './caseOpening.scss';
import { useConfig, useProfile } from '~frontend/components/hooks';
import { ConsoleLogger } from '@nestjs/common';
import { useOpenModal } from '~frontend/components/modals/hooks';

interface SliderItemProps {
  getGame: OpenCaseType;
  //isBonusPrize?: any[];
  isFastEndBtnClicked?: any;
}

const SliderItem: FunctionComponent<SliderItemProps> = ({
  getGame: {
    getGame: { getItem: wonItem },
    getItems,
  },
  getGame,
  //isBonusPrize,
  isFastEndBtnClicked,
}) => {
  const [gameStatus] = useStatusGame();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const prizeRef = useRef<HTMLDivElement>(null);
  const [prizeItemSize, setPrizeItemSize] = useState(0);
  const [wripperSize, setWripperSize] = useState(0);
  const [countOpen] = useGameCount();
  const [sliderProps] = useSliderStyle();
  const [animationName, setAnimationName] = useState('');
  const [isSuperPrizeGame] = useSuperPrizeMode();
  const getConfig = useConfig();
  const getProfile = useProfile();
  const { onShow } = useOpenModal();
  const getPrizeOffset = (
    itemSize: number,
    prizeIndex: number,
    containerCenter: number,
  ) => {
    return itemSize * prizeIndex - (containerCenter - itemSize / 2);
  };

  //console.log('isFastEndBtnClicked', isFastEndBtnClicked);

  const isMobile =
    getConfig?.userAgent.match(
      /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i,
    ) ?? false;

  // console.log('wonItem', wonItem);
  // console.log('items', getItems);
  // console.log('getGame', getGame);

  // const rearrangeItems = (wonItem, getItems) => {
  //   // Сортируем items по цене (по возрастанию)
  //   const sortedItems = [...getItems].sort((a, b) => a.price - b.price);

  //   // Находим самый дешевый и второй по дешевизне элемент
  //   const cheapestItem = sortedItems[0];
  //   const secondCheapestItem = sortedItems[1];

  //   // Находим индекс wonItem в getItems
  //   const wonItemIndex = getItems.findIndex((item) => item.id === wonItem.id);

  //   // Если wonItem найден, производим перестановку
  //   if (wonItemIndex !== -1) {
  //     // Копируем оригинальный массив, чтобы не изменять его напрямую
  //     const newItems = [...getItems];

  //     // Вставляем самый дешевый элемент перед wonItem
  //     newItems.splice(wonItemIndex, 0, cheapestItem);

  //     // После wonItem вставляем второй по дешевизне элемент
  //     // Находим новый индекс wonItem после вставки cheapestItem
  //     const newWonItemIndex = newItems.findIndex(
  //       (item) => item.id === wonItem.id,
  //     );
  //     newItems.splice(newWonItemIndex + 1, 0, secondCheapestItem);

  //     return newItems;
  //   }

  //   // Если wonItem не найден, возвращаем оригинальный массив без изменений
  //   return getItems;
  // };

  // getItems = rearrangeItems(wonItem, getItems);

  const setSize = () => {
    setPrizeItemSize(
      countOpen > 2
        ? prizeRef?.current.offsetHeight
        : prizeRef?.current.offsetWidth,
    );
    setWripperSize(
      countOpen > 2
        ? wrapperRef?.current.offsetHeight
        : wrapperRef?.current.offsetWidth,
    );
  };

  useEffect(() => {
    if (!prizeRef?.current) {
      return;
    }

    setSize();

    window.addEventListener('resize', setSize);

    return () => {
      window.removeEventListener('resize', setSize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperRef]);

  const getRandomIntInRange = (min: number, max: number): number => {
    const minNumber = Math.ceil(min);
    const maxNumber = Math.floor(max);

    return Math.floor(Math.random() * (maxNumber - minNumber + 1) + minNumber);
  };

  const getPrizeAdditionalOffset = useCallback((itemSize: number): number => {
    //console.log('itemSize', itemSize);
    const center = itemSize / 3;
    //console.log('center', center);

    //const randomOffset = 0;
    const randomOffset = getRandomIntInRange(-center + 1, center - 1);
    //console.log('randomOffset', randomOffset);

    return randomOffset;
  }, []);

  const prizeIndexOffset = useMemo(() => {
    let prizeOffset = getPrizeOffset(
      prizeItemSize,
      countOpen > 2 ? 72 : 72,
      wripperSize / 2,
    );

    // console.log('prizeOffset', prizeOffset);
    // console.log('prizeItemSize', prizeItemSize);
    // console.log('wripperSize', wripperSize);

    if (countOpen <= 5) {
      if (isMobile) {
        //console.log('MaybeMob');
        //to do maybe delete === 120px of mobile card
        prizeOffset =
          countOpen > 2
            ? prizeOffset + prizeItemSize / 1.2
            : prizeOffset + prizeItemSize / 1.5;
      } else {
        //console.log('notMob');
        prizeOffset = prizeOffset - prizeItemSize / 1.5;
      }
    }

    const additionalOffset = getPrizeAdditionalOffset(prizeItemSize);

    // console.log('additionalOffset', additionalOffset);
    // console.log('gamestatus', gameStatus);
    if (gameStatus === 3) {
      return prizeOffset;
    }

    return prizeOffset + additionalOffset;
  }, [
    countOpen,
    gameStatus,
    getPrizeAdditionalOffset,
    prizeItemSize,
    wripperSize,
  ]);

  useEffect(() => {
    if (gameStatus === 3) return;

    const animationId = `customSlide-${Date.now()}`;
    setAnimationName(animationId);
    let keyframes = '';

    if (countOpen === 1) {
      keyframes = `
    @keyframes ${animationId} {
      0% {
        transform: translate3d(0px, 0px, 0px);
        animation-timing-function: cubic-bezier(0.32, 0.64, 0.45, 1); /* Плавное начало */
      }
      90% {
        transform: translate3d(-${prizeIndexOffset - 200}px, 0px, 0px);
        animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1); /* Начинаем замедляться */
      }
      100% {
        transform: translate3d(-${prizeIndexOffset}px, 0px, 0px);
        animation-timing-function: cubic-bezier(0.68, 1.12, 0.19, 1); /* Резкое ускорение в конце */
      }
    }
  `;
    } else if (countOpen === 2) {
      keyframes = `
      @keyframes ${animationId} {
        0% {
          transform: translate3d(0px, 0px, 0px);
          animation-timing-function: cubic-bezier(0.32, 0.64, 0.45, 1); /* Плавное начало */
        }
        90% {
          transform: translate3d(-${prizeIndexOffset - 150}px, 0px, 0px);
          animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1); /* Начинаем замедляться */
        }
        100% {
          transform: translate3d(-${prizeIndexOffset + 30}px, 0px, 0px);
          animation-timing-function: cubic-bezier(0.68, 1.12, 0.19, 1); /* Резкое ускорение в конце */
        }
      }
    `;
    } else if (countOpen > 2) {
      keyframes = `
      @keyframes ${animationId} {
        0% {
          transform: translate3d(0px, 0px, 0px);
          animation-timing-function: cubic-bezier(0.32, 0.64, 0.45, 1); /* Плавное начало */
        }
        90% {
          transform: translate3d(0px, -${prizeIndexOffset - 30}px, 0px);
          animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1); /* Начинаем замедляться */
        }
        100% {
          transform: translate3d(0px, -${prizeIndexOffset + 35}px, 0px);
          animation-timing-function: cubic-bezier(0.68, 1.12, 0.19, 1); /* Резкое ускорение в конце */
        }
      }
    `;
    }

    let styleTag = document.getElementById(
      'dynamic-slider-styles',
    ) as HTMLStyleElement;
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'dynamic-slider-styles';
      document.head.appendChild(styleTag);
    }

    styleTag.innerHTML += keyframes;
  }, [gameStatus, prizeIndexOffset]);

  // const sliderStyle = useMemo(() => {
  //   if (!sliderProps || !animationName) return { animation: 'unset' };

  //   return {
  //     animation: `${animationName} 13s forwards`,
  //   };
  // }, [sliderProps, animationName]);

  useEffect(() => {
    if (isFastEndBtnClicked) {
      const element = wrapperRef.current;
      if (element) {
        element.style.animation = 'none'; // Останавливаем текущую анимацию
        void element.offsetWidth; // Форсируем ре-рендер
        element.style.animation = `${animationName} 3s forwards`; // Новая анимация с меньшей длительностью
      }
    }
  }, [isFastEndBtnClicked]);

  const sliderStyle = useMemo(() => {
    if (!sliderProps) {
      return {
        transform: 'unset',
      };
    }

    if (!sliderProps || !animationName) return { animation: 'unset' };

    const { timeout } = sliderProps;

    // //Открываем модалку если есть призовая игра Luckymodal
    // if (
    //   isBonusPrize.find((game) => game.gameId === getGame?.getGame?.id)
    //     .isBonusPrize &&
    //   gameStatus === 2
    // ) {
    //   setTimeout(() => {
    //     console.log('will show lucky modal');
    //     onShow('LuckyWinModal', { getGame });
    //   }, 14500);
    // }

    //console.log('isBonusPrize111', isBonusPrize);
    //Находим ту самую игру в массиве и смотрим бонусная ли она чтобы применить бонусную анимацию
    // if (
    //   isBonusPrize.find((game) => game.gameId === getGame?.getGame.id)
    //     .isBonusPrize
    // ) {
    //   return {
    //     animation: `${animationName} 14s forwards`,
    //   };
    // } else {
    return {
      transform:
        countOpen > 2
          ? `translate3d(0px, -${prizeIndexOffset}px, 0px)`
          : `translate3d(-${prizeIndexOffset}px, 0px, 0px)`,
      transition: `${
        gameStatus === 3 ? 2500 : timeout
      }ms cubic-bezier(0.32, 0.64, 0.45, 1)`,
    };
    //}
  }, [countOpen, prizeIndexOffset, sliderProps, gameStatus, animationName]);

  return (
    // <div className={`case_previews_item`} style={sliderStyle} ref={wrapperRef}>
    //   {_.map(getItems, (getItem, index: number) => (
    //     <img
    //       // data-win={index === 70}
    //       // ref={prizeRef}
    //       src={`${
    //         index === 70 ? wonItem.getImage : getItem.getImage
    //       }/350fx350f`}
    //       alt={index === 70 ? wonItem.getName : getItem.getName}
    //       // width={item.width}
    //       // height={item.height}
    //       className="case_preview_image"
    //     />
    //   ))}
    // </div>
    <>
      <div
        className={`case-play-slider-wrap ${
          countOpen > 2 ? 'case-play-slider-two-wrap' : ''
        }`}
        style={sliderStyle}
        ref={wrapperRef}
      >
        {_.map(getItems, (getItem, index: number) => (
          <div
            className={`${
              countOpen > 2 ? 'case-slider-item-many' : 'case-slider-item'
            } ${gameStatus === 3 && (index === 70 ? 'show' : 'hide')} ${
              countOpen === 2 ? 'two-rows' : ''
            }`}
            key={`${getItem.id}-${index}`}
            data-win={index === 70}
            ref={prizeRef}
          >
            <div
              className={`in-case-item ${
                countOpen > 2 ? 'in-case-item-many ' : ''
              } status-4`}
              data-rar={index === 70 ? wonItem.color : getItem.color}
              data-audio="5.wav"
              data-volume="0.4"
            >
              <div className="in-case-item-wrap">
                <div className="in-case-item-bg" />
                <div className="img">
                  <img
                    src={`${
                      index === 70 ? wonItem.getImage : getItem.getImage
                    }/350fx350f`}
                    alt={index === 70 ? wonItem.getName : getItem.getName}
                  />
                </div>
                {gameStatus === 3 && index === 70 && (
                  <div className="in-case-info">
                    <div className="in-case-item-name">
                      <GetName getItem={wonItem} type={0} />
                    </div>
                    <div className="in-case-item-desc">
                      <GetName getItem={wonItem} type={1} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default memo(SliderItem);
